import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

export default function ModuleSelect(props) {
  const {
    value,
    onChange,
    reset,
    title = undefined,
    placeholder = undefined,
    type = 'client',
    moduleType = 'all',
    isMulti = true,
    clientIDs = [],
    error = undefined,
  } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState(null);

  const loadModules = useCallback(async () => {
    await axios
      .post(axiosPath('api_r_user_global_getModules'), {
        type,
        moduleType,
        clientIDs,
      })
      .then((r) => {
        if (isMounted.current) {
          setOptions(r.data);
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [type, moduleType, clientIDs]);

  useEffect(() => {
    setOptions(null);
    loadModules();
  }, [reset]);

  if (isMulti) {
    return (
      <AppMultiSelect
        icon={<AppRemixIcon icon="globe" />}
        options={options}
        title={
          title ||
          ReactDOMServer.renderToString(
            <Translator file="admin" name="general.modules" />
          )
        }
        placeholder={
          placeholder ||
          ReactDOMServer.renderToString(
            <Translator file="admin" name="general.select-one-more-modules" />
          )
        }
        value={value}
        onChange={(opt) => onChange(opt)}
        allowSelectAll
        isLoading={!options}
        hasSearchBox
        hasSelectOptions
        error={error}
        isDisabled={clientIDs.length === 0}
      />
    );
  }

  return (
    <AppSingleSelect
      icon={<AppRemixIcon icon="globe" />}
      options={options}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="admin" name="general.modules" />
        )
      }
      placeholder={
        placeholder ||
        ReactDOMServer.renderToString(
          <Translator file="admin" name="general.select-a-module" />
        )
      }
      value={value}
      onChange={(opt) => onChange(opt)}
      isLoading={!options}
      hasSearchBox
      error={error}
      isDisabled={clientIDs.length === 0}
    />
  );
}
